<template>
  <aside
    v-if="isDesktop"
    class="z-30 w-[280px] bg-gray-200 pl-1 pt-12"
    data-test="appList__navbar-aside"
  >
    <ul>
      <li
        v-for="item in formatProductGroupMenu"
        :key="hash(item)"
        :class="item.level === 'group' ? 'mb-5' : 'mb-1'"
        class="font-bold last:mb-0"
      >
        <div v-if="item.level === 'group'">
          <div>
            <TheNuxtLink
              v-if="validIsNuxtLink(item)"
              :to="provideLinkPath(item.link?.url || '')"
              :title="item.name"
              active-class="nuxt-link-active"
              class="category-link"
            >
              {{ item.name }}
            </TheNuxtLink>
            <p v-else class="mb-1 py-1 text-sm text-gray-600">
              {{ item.name }}
            </p>
          </div>
          <ul v-if="item.subMenus.length">
            <li
              v-for="subItem in item.subMenus"
              :key="hash(subItem)"
              class="mb-1 last:mb-0"
            >
              <TheNuxtLink
                :to="provideLinkPath(subItem.link?.url || '')"
                :title="subItem.name"
                class="category-link"
                active-class="nuxt-link-active"
                @click="handleClick(subItem)"
              >
                {{ subItem.name }}
              </TheNuxtLink>
            </li>
          </ul>
        </div>
        <TheNuxtLink
          v-else
          :to="provideLinkPath(item.link?.url || '')"
          :title="item.name"
          class="category-link"
          active-class="nuxt-link-active"
          @click="handleClick(item)"
        >
          {{ item.name }}
        </TheNuxtLink>
      </li>
    </ul>
  </aside>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatProductMenu } from '@/stores/menuStore';

  const { locale } = useI18n();
  const { isCN } = useLanguage();
  const { isDesktop } = useScreen();

  const menuStore = useMenuStore();
  const { formatProductGroupMenu } = storeToRefs(menuStore);

  const provideLinkPath = (url: string): string => {
    if (isCN.value) {
      return url;
    }
    if (url.includes(`/${locale.value}/marketplace`)) {
      return url.replace('/marketplace', '');
    }
    return url;
  };

  const handleClick = (payload: IFormatProductMenu): void => {
    window.gtag('event', 'site_click', {
      Item: 'CategoryName',
      Item_Name: payload.name,
    });
  };
</script>

<style lang="scss" scoped>
  .category-link {
    @apply hover:text-blue-400;

    &.nuxt-link-active {
      @apply text-blue-400 underline;
    }
  }
</style>
